module.exports = __webpack_public_path__ + "static/partial.66ed2dac.png";